import { useState,useContext } from 'react';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ModalContainer,UIcon,IconContainer, MainContentContainer1, SubmitContainer, StyleButton, StyleInput, StyleLabel } from '../Modal/CreateAdminUser'
import { FilterDropDown } from '../../../../ui-components';
import { useSettingModal } from '../../../../hooks/Context';
import apiCall from '../../../../utils/apiCall';
import { NotificationContext } from '../../../../providers/notification';

const CreateSetUp = () => {
    const SetUpInterviewId = 0;
    const [SetUpInterviewName, setSetUpInterviewName] = useState<string>('');
    const [SetUpInterviewVenue, setSetUpInterviewVenue] = useState<string>('');
    let  SetUpInterviewDate:any = '';
    const [date, setDate] = useState<any>(null);
    const [time, setTime] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const {showNotification } = useContext(NotificationContext);
    const {setShowModal} = useSettingModal();
    const queryClient = useQueryClient();

    const handleCreateSetUp = async() =>{
        SetUpInterviewDate = `${date}T${time}`;

        const data = {
          Date: new Date(SetUpInterviewDate),
          Venue:SetUpInterviewVenue,
          Id:0,
          IsActive:false
        }

        setLoading(true);
        return await (await apiCall().post('/SetUp/CreateUpdateInvitation', data)).data;
    }

    const AddSetUpInterviewMutation = useMutation(handleCreateSetUp,{
      
      onSuccess:()=>{
        showNotification({
          type:'success',
          message: 'Interview Successfully Created',
        })
        setShowModal(false);
        setLoading(false);
        queryClient.invalidateQueries(['all-SetUpInterview']);
      },
     
      onError(error:any, variables, context) {
        setShowModal(false);
        showNotification({
          type:'error',
          message: error.message,
        })  
        setLoading(false);
      },

      
    })

    const handleForm = (e: any) => {
      e.preventDefault();

      const currentDate = new Date();

      if(SetUpInterviewVenue?.length === 0) {
        showNotification({
          type: 'error',
          message: 'SetUpInterview venue is required'
        })
        return;
      }

      if(date === null) {
        showNotification({
          type: 'error',
          message: 'SetUpInterview Date is required'
        }) 
        
        return;
      }
      
      if(date < currentDate) {
        showNotification({
          type: 'error',
          message: 'Interview date cannot be in the past'
        })
        return;
      }

      if(time === null) {
        showNotification({
          type: 'error',
          message: 'Interview time is required'
        })
        return;
      }

      if(date && time && SetUpInterviewVenue) {
        AddSetUpInterviewMutation.mutate();
      }
      
    }

  return (
    <ModalContainer>
    <div>
      <div>
        <div>
          <IconContainer><UIcon /></IconContainer>
          <span>Set Up Interview</span>
        </div>
      </div>
      <MainContentContainer1 onSubmit={handleForm}>
        {/* <StyleLabel style={{width:'100%'}}>
            <span>SetUpInterview Type</span>
            <FilterDropDown replace='true' options={options} text='SetUpInterview type' border="1px solid lightgray" bg='white' />

        </StyleLabel> */}
        {/* <StyleLabel>
            <span>Name</span>
            <StyleInput onChange={(e:any) => setSetUpInterviewName(e.target.value)} placeholder='Name' />
        </StyleLabel> */}
        <StyleLabel>
            <span>Venue</span>
            <StyleInput onChange={(e:any) => setSetUpInterviewVenue(e.target.value)} placeholder='Venue' />
        </StyleLabel>
        <StyleLabel>
            <span>Date</span>
            <StyleInput onChange={(e:any) => setDate(e.target.value)} type='date' />
        </StyleLabel>
        <StyleLabel>
            <span>Time</span>
            <StyleInput onChange={(e:any) => setTime(e.target.value)} type='time' />
        </StyleLabel>
        <SubmitContainer>
            <span onClick={()=>setShowModal(false)}>Cancel</span>
            <StyleButton >
              {!loading ?'Submit':'Loading...'}
            </StyleButton>
        </SubmitContainer>

      </MainContentContainer1>
      </div>
    </ModalContainer>
  )
}

export default CreateSetUp